import React, { Component } from 'react';
import { connect } from 'react-redux'
// import {
//     getProject,
// } from './../redux/actions/actions'
import { Grid, Row, Col, Button } from 'react-bootstrap/lib';
import { history } from '../redux/store';
import PropTypes from 'prop-types'
import ProjectHeader from './ProjectHeader';
import Slider from 'react-slick/lib';
import ReactCompareImage from 'react-compare-image';
/*
const mapStateToProps = state => {
    return {
        _project: state.projects.project,
        user: state.authUser.user,
        isAuth: state.authUser.isAuth
    }
}
*/
class RuinedCityProject extends Component {

    componentDidMount() {
        document.body.className = 'posts show'
    }

    componentWillMount() {
        //this.props.getProject(this.props.match.params.id)
    }

    componentWillUnmount() {
        document.body.className = ''
    }

    render() {

        const project = {
            "id": 1,
            "title": "Ruined City",
            "description": "World War 2 Tank Driving Demo",
            "tags": "Computer Graphics, OpenGL, Particle Effects",
            "thumbnail_img": "assets/logo-ruined-city.png",
            "feature_img": "assets/header-ruined-city.png",
            "role": "Graphics Programmer",
            "context": "University Project",
            "period": "Fall 2016",
            "technologies": []
        }

        const { claps, title, description, technologies } = project;

        let tech;
        /*
        if (technologies) {
            tech = this.props._project.technologies.map((technologie) =>
                <div key={technologie.id} className="tech-box">
                    <img src={"/" + technologie.logo} className="project-logo" alt={technologie.name} />
                    <h4 className="title">{technologie.name}</h4>
                </div>
            );
        }
        */
        const technologiesSliderSettings = {
            arrows: false,
            infinite: true,
            centerPadding: "0px",
            slidesToShow: 4,
            speed: 1000,
            autoplay: true,
        };
        const layersSliderSettings = {
            arrows: true,
            infinite: true,
            centerPadding: "0px",
            slidesToShow: 1,
            speed: 1000,
            autoplay: false,
        };

        return (
            <div>
                <ProjectHeader project={project} />
                <main>
                    <section className="main-section">
                        <Grid>
                            <Row>
                                <Col md={12}>
                                    {/* {this.props.isAuth ? <Button bsStyle="primary" style={{ float: 'right' }} onClick={() => { history.push('/editor') }}>Edit</Button> : ''} */}
                                    <h4 className="sub-heading">Project</h4>
                                    <h1 className="heading pink"><span className="pink">{title}</span> <br /> {description}</h1>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col md={12}>
                                    <p style={{ margin: '0 10%' }}>
                                        <b>Ruined City</b> is an interactive 3D game written in C# using the OpenTK wrapper of the 3.3 OpenGL graphics API, the physics library BulletSharp, and sound library irrKlang. It's main features are an user controlled Battle Tank, Shadow Mapping, Normal Mapping, Particle Systems and Terrain Texture Blending.
                                    </p>
                                </Col>
                                <Col md={12} style={{ textAlign: 'center' }}>
                                    <Slider {...layersSliderSettings}>
                                        <iframe width="920" height="518" src="https://www.youtube.com/embed/GsO1ZsHhM40" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                        <iframe width="920" height="518" src="https://www.youtube.com/embed/ODepJHc5f0U" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                    </Slider>                                    
                                </Col>
                            </Row>

                            <br />
                            <Row>
                                <Col md={12}>
                                    <h4 className="sub-heading" style={{ marginBottom: '0' }}>Rendering</h4>
                                </Col>

                                <Col md={12}>
                                    <h2 className="heading pink"><span>Tiger Heavy Tank</span></h2>
                                    <br />
                                    <Col md={12}>
                                        <img className="img-box" src="../assets/ruined/tiger.gif" alt="Tiger Heavy Tank" width="100%" />
                                    </Col>
                                    <Col md={12}>
                                        <br />
                                        <p>
                                            The main element in our Demo is the user-controlled <a href="https://en.wikipedia.org/wiki/Tiger_I" target="_blank">Tiger Heavy Tank</a>. Most of the rendering techniques implemented on the engine are focused on this object.
                                            The metallic look of the tank was implemented using the <a href="http://www.codinglabs.net/article_physically_based_rendering_cook_torrance.aspx" target="_blank">Cook Torrance</a> illumination model, and <a href="https://learnopengl.com/Advanced-Lighting/Normal-Mapping" target="_blank">Normal Mapping</a> to highlight the surface details of the mesh.
                                        </p>
                                        <p>
                                            To make the Demo interactive, the Tank is supposed to move around the scene. A war tank has a pair of moving threads that needed to be animated in order for the movement to look realistic.
                                            A special Shader takes care of animating these threads when the tank is moving or rotating, this is done by translating the texture coordinates of the thread meshes based on the elapsed time.
                                        </p>
                                        <p>
                                            The actual translation and rotation of the tank is handled by the Physics Library <a href="https://andrestraks.github.io/BulletSharp/" target="_blank">Bullet Sharp</a>, which incorporates physics quantities like velocity, acceleration, gravity, torque and friction.
                                        </p>
                                    </Col>
                                </Col>

                                <Col md={12}>
                                    <h2 className="heading pink"><span>Shadow Mapping</span></h2>
                                    <br />
                                    <Col md={12}>
                                        <img className="img-box" src="../assets/ruined/shadows.png" alt="Shadow Mapping" width="100%" />
                                    </Col>
                                    <Col md={12}>
                                        <br />
                                        <p>
                                            Shadows are created when a surface blocks incoming light. <a href="https://learnopengl.com/Advanced-Lighting/Shadows/Shadow-Mapping" target="_blank">Shadow mapping</a> or shadowing projection is a two steps process by which shadows are added to 3D computer graphics.
                                            This concept was introduced by Lance Williams in 1978, in a paper entitled "Casting curved shadows on curved surfaces."
                                            Since then, it has been used both in pre-rendered and real-time scenes in many console and PC games.
                                        </p>
                                        <p>
                                            During the first pass a Shadow Map texture is generated by rendering the scene from the point of view of the light source and saving of the contents from the <a href="https://en.wikipedia.org/wiki/Z-buffering" target="_blank">depth buffer</a>.
                                            In our demo this light source is a <a href="https://en.wikipedia.org/wiki/Shading#Directional_lighting" target="_blank">directional light</a> acting as the sunlight, we use an <a href="https://en.wikipedia.org/wiki/Orthographic_projection" target="_blank">orthographic projection</a> for rendering the Shadow Map.
                                        </p>
                                        <p>
                                            On the second pass, the scene is rendered as usual, and the Shadow Map is used to determine whether or not each fragment is in shadow.
                                            For each fragment in the scene, the Shadow Map tells us whether or not the light is being occluded by some geometry that is closer to the light source.
                                        </p>
                                    </Col>
                                </Col>

                                <Col md={12}>
                                    <h2 className="heading pink"><span>Terrain Shader</span></h2>
                                    <br />
                                    <Col md={12}>
                                        <img className="img-box" src="../assets/ruined/terrain2.png" alt="Terrain Shader" width="100%" />
                                    </Col>
                                    <Col md={12}>
                                        <br />
                                        <p>
                                            To make Terrain creation more flexible for the Demo, we wanted to blend together multiple textures on the same terrain mesh. Something similar to <a href="https://en.wikipedia.org/wiki/Shading#Directional_lighting" target="_blank">Vertex Painting</a>.
                                            A cobblestone like texture is used for the main road, to signal the path for the Tiger Tank. A different rubble texture is used for the ground on areas where damaged buildings are located. And a simple dirt texture for the rest of the terrain.
                                        </p>
                                        <p>
                                            The Terrain mesh uses a special Shader that is able to mix these 3 textures. This is done with the help of a fourth masking texture that indicates how much of the previous textures should be used to color
                                            each fragment of the terrain mesh.
                                        </p>
                                        <img src="../assets/ruined/terrainshader.png" alt="Terrain Shader" width="100%" />
                                        <p>
                                            Normal Mapping is also used for each texture to add more detail to the ground.
                                            This provides the engine with a highly detailed description of the surface shape, without having to add such detail in the actual mesh geometry.
                                        </p>
                                    </Col>
                                </Col>

                                <Col md={12}>
                                    <br />
                                    <h4 className="sub-heading" style={{ marginBottom: '0' }}>Particles</h4>
                                </Col>

                                <Col md={12}>
                                    <h2 className="heading pink"><span>Particle System</span></h2>
                                    <br />
                                    <Col md={12}>
                                        <img className="img-box" src="../assets/ruined/particles.gif" alt="Particle System" width="100%" />
                                    </Col>
                                    <Col style={{ textAlign: 'center' }} md={12}>
                                        <br />
                                        <p>
                                            The Demo Scene includes a number of <a href="https://en.wikipedia.org/wiki/Particle_system" target="_blank">Particle Systems</a> for different kind of effects. The most interesting ones being animated fire from buildings
                                            and smoke coming out of rubble and the background. The Particle System used to achieve these effects was designed based on how the <a href="https://docs.unity3d.com/Manual/comp-ParticlesLegacy.html" target="_blank">Unity 3D Legacy Particle System</a> worked. The goal was to be able to find effects created for the Unity Particle System and easily recreate them in
                                            our own system, which would save a lot of time for this assignment.
                                        </p>
                                        <p>
                                            The core of the system is the Particle Emitter. Responsible for the creation, update and destruction of particles based on a certain number of configuration parameters.
                                            Particles share a number of attributes like position, velocity, color, time to live and size. They are represented by a camera aligned quad. For a given effect, each particle
                                            can be rendered with the same texture, which also has transparency support.
                                        </p>
                                        <p>
                                            Only 2 particle effects were implemented for the Demo, a smoke effect and a fire effect. The last one is an example of an animated texture that uses a texture atlas.
                                            The atlas has four frmaes of a fire animation sequence, one next to the other. The particle quad uses this texture atlas, and the texture coordinates are changed repeatedly in order to index into the different frames of the animation
                                        </p>
                                        <img src="../assets/ruined/fire.gif" alt="Terrain Shader" />
                                    </Col>
                                </Col>
                            </Row>
                        </Grid>
                    </section>
                    {/* 
                    <section>
                        <Grid>
                            <Row>
                                <Col md={12}>
                                    <h4 className="sub-heading">Collaborators</h4>
                                    <h1 className="heading blue"><span className="blue">students</span> of computer science</h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12} style={{ textAlign: 'center' }}>
                                    <div style={{ margin: "0 -3em" }}>
                                        <Slider {...layersSliderSettings}>
                                            <div className="tech-box">
                                                <img src="../assets/layer-middleware.png" width="100%" alt='Middleware Layer' />
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/layer-renderer.png" width="100%" alt='Low Level Renderer Layer' />
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/layer-scene.png" width="100%" alt='Scene Layer' />
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/layer-effects.png" width="100%" alt='Visual Effects Layer' />
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/layer-frontend.png" width="100%" alt='Frontend Layer' />
                                            </div>
                                        </Slider>
                                    </div>
                                </Col>
                            </Row>
                        </Grid>
                    </section> */}
                </main>
            </div>
        );
    }
}

// Project.propTypes = {
//     params: PropTypes.object.isRequired
// }
/*
export default connect(mapStateToProps, {
    getProject
})(Project);
*/
export default connect()(RuinedCityProject);


// WEBPACK FOOTER //
// ./src/components/RuinedCityProject.js